import
     {useContext} from "react";
import ElementRenderer
    from "./ElementRenderer";
import {FormData} from "./FormProvider";
import ErrorContainer
    from "./elements/ErrorContainer";
import ErrorList
    from "./elements/ErrorList";
import PoweredByFormitize
    from "./PoweredByFormitize";
import {Button} from "@mui/material";

/**
 * @param template          Object representing the form template
 * @param submission        Object representing the submission data (if any). Used to populate the form with previous submission data.
 * @param defaultAnswers    Object representing the default answers (if any). Identical payload to submission.
 *                          Used to populate the form with default answers if no submission data is present.
 * @returns {JSX.Element}
 * @constructor
 */
const FormRenderer = ({
                          template,
                          defaultAnswers = {},
                          onSubmit,
                          showTagline = true,
                          errors = [],
                      }) => {
    let {
        state
    } = useContext(FormData);

    const headers = [];

    Object.keys(template?.header).map(key => {
        headers.push(template?.header[key]);
    });

    return (
        <>
            <form method="post" action="/" className='fz-form' onSubmit={onSubmit}>
                {headers.map((template, index) => (
                    <ElementRenderer key={index}
                                     template={template}
                                     defaultAnswers={defaultAnswers}/>
                ))}

                {errors.length > 0 && (
                    <ErrorContainer>
                        <h3 className='fz-form-error-heading'>There appears to be a problem...</h3>
                        {errors.map((error, index) => (
                            error.field ? (
                                <dl className='fz-form-error-fields-list' key={index}>
                                    <dt className='fz-form-error-field-term'>{error.field.content.question}
                                        <a href={`#${error.field.id}`}>(go to)</a>
                                    </dt>
                                    <dd className='fz-form-error-field-definition'>
                                        <ErrorList errors={error.validationResult}/>
                                    </dd>
                                </dl>
                            ) : (
                                <div className='fz-form-field-error-messages-list-item' key={index}>{error}</div>
                            )
                        ))}
                    </ErrorContainer>
                )}

                <div className='fz-form-actions'>
                    <Button color='success' variant="contained" className='fz-form-actions-submit' disabled={state.submitting} type='submit'>{state.submitting ? "Submitting..." : "Submit"}</Button>
                </div>

                {showTagline && <PoweredByFormitize/>}
            </form>
        </>

    )
}

export default FormRenderer;